import React, { Component } from 'react';
import Header from '../../components/Header';
import { onGoBack } from '../../common/globals';
import withGoBack from '../../common/withGoBack';
import withTableName from '../../common/withTableName';
import { getTableCaseByCaseId } from '../../utils/db';
import Bugsnag from '../../helpers/bugsnag';

class AcmFlagDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flagsData: []
    };
  }

  _getACMCaseFlags = async () => {
    try {
      const { params: { id }, tableName } = this.props;
      const flagsArr = [];
      const caseRes = await getTableCaseByCaseId(id, tableName);
      if (caseRes && caseRes.ACMCaseFlags !== null) {
        const ACMCaseFlagsArray = caseRes.ACMCaseFlags.split(';');
        ACMCaseFlagsArray.map((value) => {
          flagsArr.push(value.split(','));
        });
        const newArray = flagsArr.filter((value) => JSON.stringify(value) !== '[""]');

        const flagsValue = newArray.slice(0).map(
          ([reason, severity, comments]) => ({
            reason, severity, comments
          })
        );
        this.setState({
          flagsData: flagsValue
        });
        this._onGoBack();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      await this._getACMCaseFlags();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { goBack } = this.props;
    const { flagsData } = this.state;
    return (
      <section className="list-section">
        <Header
          title="ACM Flags"
          goBack={() => onGoBack(goBack)}
        />
        <section className="sets-section">
          <div className="container">
            {
              flagsData.map((item, key) => (
                <div className="row acm-bottom-border mt-2" key={key}>
                  <label htmlFor="heading" className="acm-gray-label">Reason:</label>
                  <div className="mb-2">
                    <span>{item.reason}</span>
                  </div>
                  <label htmlFor="severity" className="acm-gray-label">Severity:</label>
                  <div className="mb-2">
                    <span>{item.severity}</span>
                  </div>
                  <label htmlFor="comments" className="acm-gray-label">Comments:</label>
                  <div className="mb-2">
                    <span>{item.comments}</span>
                  </div>
                </div>
              ))
            }
          </div>
        </section>
      </section>
    );
  }
}

export default withTableName(
  withGoBack(
    AcmFlagDetails
  )
);
